import styles from "./time-alerts-radio.module.css";

import classNames from "classnames";
interface IRadioProps {
  checked?: any;

  onChange?: any;
  title: string;
  startTime: string | null;
  endTime: string | null;
  disabledInteraction?: boolean;
}
export default function TimeAlertRadio(props: IRadioProps) {
  const { title, startTime, endTime, disabledInteraction, onChange } = props;

  const onClick = () => {
    if (disabledInteraction) return;

    onChange();
  };

  return (
    <div
      className={classNames(styles["time-alerts"], {
        [styles["clickable"]]: !disabledInteraction,
      })}
    >
      <input
        onChange={onClick}
        checked={props.checked}
        type={"radio"}
        className={styles["input-radio"]}
      ></input>
      <div onClick={onClick} className={styles["label-container"]}>
        <div
          className={classNames({
            [styles["selected-interval-title"]]: props.checked,
            [styles["time-interval-title"]]: !props.checked,
          })}
        >
          {title}
        </div>
        {startTime && endTime && (
          <div onClick={onClick} className={styles["time-interval-hours"]}>
            {startTime} - {endTime}
          </div>
        )}
      </div>
    </div>
  );
}
